import React from "react";

const UserInfoContext = React.createContext({
    userInfo:{},
    setUserInfo: () => {}
});

export default UserInfoContext;